<template>
    <div class="grupo">
        <v-container grid-list-xl fluid class="pt-0">
            <v-layout row wrap>
                <v-flex sm4 v-if="gradoExpand">
                    <v-card>
                        <v-toolbar color="primary" dark flat>
                            <v-toolbar-title>
                                <v-icon medium>fa-cog</v-icon>
                                Detalles del Grado
                            </v-toolbar-title>
                            <v-divider class="mx-2" inset vertical></v-divider>

                            <v-spacer></v-spacer>
                            <v-toolbar-items>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn icon color="primary" dark @click="gradoExpand = false">
                                            <v-icon v-on="on">{{ getGradoSeccionIcon() }}</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Ocultar</span>
                                </v-tooltip>
                            </v-toolbar-items>
                        </v-toolbar>

                        <v-card-text>
                            <v-container fluid grid-list-xl>
                                <v-layout align-center wrap>
                                    <v-flex tag="strong" sm5 text-xs-right mr-2>Nombre:</v-flex>
                                    <v-flex sm5>{{ gradoData.nombre }}</v-flex>
                                    <v-flex tag="strong" sm5 text-xs-right mr-2>Campus:</v-flex>
                                    <v-flex sm5>{{ gradoData.campus ? gradoData.campus.nombre : "-" }}</v-flex>
                                    <v-flex tag="strong" sm5 text-xs-right mr-2>Sección:</v-flex>
                                    <v-flex sm5>{{ gradoData.seccion ? gradoData.seccion.nombre : "-" }}</v-flex>
                                    <v-flex tag="strong" sm5 text-xs-right mr-2>Nivel educativo:</v-flex>
                                    <v-flex sm5>{{ gradoData.nivel_educativo }}</v-flex>
                                    <v-flex tag="strong" sm5 text-xs-right mr-2>Secuencia:</v-flex>
                                    <v-flex sm5>{{ gradoData.secuencia }}</v-flex>
                                    <v-flex tag="strong" sm5 text-xs-right mr-2>Aut. RVOE:</v-flex>
                                    <v-flex sm5>{{ gradoData.aut_rvoe }}</v-flex>
                                    <v-flex tag="strong" sm5 text-xs-right mr-2>Curso:</v-flex>
                                    <v-flex sm5>{{ gradoData.curso }}</v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-flex>

                <v-flex :class="gradoExpand ? 'sm8' : 'sm12'">
                    <v-card>
                        <v-toolbar color="primary" dark flat>
                            <v-scroll-x-transition>
                                <template v-if="!gradoExpand">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-btn icon color="primary" dark @click="gradoExpand = true">
                                                <v-icon v-on="on">{{ getGradoSeccionIcon() }}</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Contraer</span>
                                    </v-tooltip>
                                </template>
                            </v-scroll-x-transition>

                            <v-toolbar-title>
                                <v-icon medium>fa-cog</v-icon>
                                Lista de Grupos
                            </v-toolbar-title>

                            <v-divider class="mx-2" inset vertical></v-divider>

                            <v-flex sm3 class="pa-0" style="max-width: 190px">
                                <v-overflow-btn
                                    v-model="grupoEstado"
                                    label="Grupo"
                                    :items="[
                                        { text: 'Todos', value: '1' },
                                        { text: 'Habilitados', value: '2' },
                                        { text: 'Deshabilitados', value: '3' }
                                    ]"
                                    hide-details
                                    class="pa-0"
                                    @change="loadGrupo()"
                                >
                                    <template v-slot:item="data">
                                        <v-list-tile-content>
                                            <v-card-text class="pa-0 ">
                                                <v-icon
                                                    :color="getIconColor(data)"
                                                    class="pr-3"
                                                    v-if="data.item.value !== '1'"
                                                    >fa-list</v-icon
                                                >
                                                {{ data.item.text }}
                                            </v-card-text>
                                        </v-list-tile-content>
                                    </template>
                                </v-overflow-btn>
                            </v-flex>

                            <v-divider class="px-1" inset vertical></v-divider>

                            <v-spacer></v-spacer>

                            <v-toolbar-items>
                                <v-btn icon @click="toogleSearch()">
                                    <v-icon medium>fa-search</v-icon>
                                </v-btn>

                                <v-expand-x-transition>
                                    <v-text-field
                                        hide-details
                                        solo
                                        v-show="searchShow"
                                        v-model="filter.search"
                                        placeholder="Filtrar"
                                        class="hidden-sm-and-down pt-2"
                                    >
                                    </v-text-field>
                                </v-expand-x-transition>

                                <v-divider class="pa-2"></v-divider>

                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn icon flat @click="openForm(null)">
                                            <v-icon medium v-on="on">fa-plus</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Agregar Grupo</span>
                                </v-tooltip>
                            </v-toolbar-items>
                        </v-toolbar>
                        <v-divider></v-divider>
                        <v-card-text class="pa-0">
                            <v-data-table
                                :headers="headers"
                                :loading="loading"
                                :pagination.sync="pagination"
                                :rows-per-page-items="pagination.rowsPerPageItems"
                                :total-items="totalItems"
                                :items="GRUPOS"
                                class="elevation-1"
                                item-key="id"
                            >
                                <v-progress-linear v-slot:progress color="green" indeterminate></v-progress-linear>
                                <template slot="items" slot-scope="props">
                                    <tr>
                                        <td>{{ props.item.letra }}</td>
                                        <td>
                                            {{
                                                props.item.empleado.nombre +
                                                    " " +
                                                    props.item.empleado.apellido_paterno +
                                                    " " +
                                                    props.item.empleado.apellido_materno
                                            }}
                                        </td>
                                        <td>
                                            <v-chip
                                                small
                                                dark
                                                :color="getChipColor(props.item)"
                                                style="font-size: 12px"
                                            >
                                                {{
                                                    props.item.status_description ? props.item.status_description : "-"
                                                }}
                                            </v-chip>
                                            <div class="action-column">
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            flat
                                                            icon
                                                            color="orange"
                                                            :disabled="loading || menuLocked"
                                                            @click="openForm(props.item)"
                                                        >
                                                            <v-icon medium v-on="on">fa-edit</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Editar Grupo</span>
                                                </v-tooltip>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            flat
                                                            icon
                                                            color="red"
                                                            :disabled="loading || menuLocked"
                                                            @click="deleteItem(props)"
                                                        >
                                                            <v-icon medium v-on="on">fa-trash</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Eliminar Grupo</span>
                                                </v-tooltip>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            flat
                                                            icon
                                                            color="grey"
                                                            :loading="loadingHistory"
                                                            :disabled="loading || menuLocked"
                                                            @click="loadHistory(props.item)"
                                                        >
                                                            <v-icon medium v-on="on">fa-archive</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Ver historial</span>
                                                </v-tooltip>
                                            </div>
                                        </td>
                                    </tr>
                                </template>
                                <template v-slot:expand="props">
                                    <v-card>
                                        <v-card-text class="py-0 pl-0 text-xs-right">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn icon flat color="red" @click="deleteItemCancel(props)">
                                                        <v-icon v-on="on">fa-close</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Cancelar acción</span>
                                            </v-tooltip>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn icon flat color="green" @click="deleteItemConfirm(props)">
                                                        <v-icon v-on="on">fa-check</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Confirmar acción</span>
                                            </v-tooltip>
                                        </v-card-text>
                                    </v-card>
                                </template>
                                <template slot="no-data">
                                    <div style="text-align: center">
                                        No existen grupos registrados en el sistema.
                                    </div>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
        <grupo-form
            v-if="showForm"
            :form-title="title"
            :grado-id="gradoData.id"
            :initial-item="editItem"
            @formCanceled="closeForm"
        >
        </grupo-form>

        <time-line
            v-if="showHistory"
            :data="historyData"
            :element="'Grupo'"
            @formCanceled="showHistory = false"
        ></time-line>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import _ from "lodash"
import Util from "@/util"
const TimeLine = () => import("@/components/widgets/records-time-line/time-line")
const GrupoForm = () => import("@/components/cobranza/nomencladores/grupo-form/grupo-form")

export default {
    components: { GrupoForm, TimeLine },
    props: {
        gradoParam: { type: Object, default: null }
    },
    data: () => ({
        searchShow: false,
        loading: false,
        title: "",
        showForm: false,
        headers: [
            { text: "Grupo", value: "letra" },
            { text: "Profesor", value: "profesor_titular" },
            { text: "Estado", value: "estado" }
        ],
        editItem: null,
        filter: {
            search: ""
        },
        totalItems: 0,

        deleteGrupoConfirmId: "",

        menuLocked: false,

        //estado de los grupos a cargar del back
        grupoEstado: "1",

        //datos del grado
        gradoData: {},
        gradoExpand: true,

        //history
        loadingHistory: false,
        showHistory: false,
        historyData: null,

        //id del grado de donde proviene
        gradoId: null
    }),

    methods: {
        toogleSearch: function() {
            this.searchShow = !this.searchShow
        },

        loadData(estado) {
            this.loading = true
            this.$store
                .dispatch("LOAD_GRUPOS", { gradoID: this.gradoId, filter: this.filter.search, grupoEstado: estado })
                .then(result => {
                    this.loading = false
                    this.totalItems = result
                })
        },

        openForm(item) {
            if (item !== null) {
                this.title = "Modificar grupo"
                this.editItem = item
            } else {
                this.title = "Nuevo grupo"
            }
            this.showForm = true
        },

        closeForm() {
            this.showForm = false
            this.editItem = null
        },

        deleteItem(props) {
            this.menuLocked = true
            this.deleteGruposConfirmId = props.item.id
            props.expanded = true
        },

        deleteItemConfirm(props) {
            if (this.deleteGruposConfirmId === props.item.id) {
                this.loading = true
                this.$store.dispatch("DELETE_GRUPO", props.item).then(() => {
                    this.loading = false
                    this.menuLocked = false
                    this.deleteGruposConfirmId = ""
                    props.expanded = !props.expanded
                })
            }
        },

        deleteItemCancel(props) {
            this.menuLocked = false
            this.deleteGruposConfirmId = ""
            props.expanded = !props.expanded
        },

        getGradoSeccionIcon() {
            return this.gradoExpand ? "fa-angle-left" : "fa-angle-right"
        },

        loadGrupo() {
            this.loadData(this.grupoEstado)
        },

        loadHistory(item) {
            this.loadingHistory = true

            let historyClassName = Util.getHistoryClassName("Grupo")
            this.$store.commit("SET_HISTORIALES_TIME_LINE_PAG", { page: 1 })
            this.$store
                .dispatch("LOAD_HISTORIALES_TIME_LINE", { class: historyClassName, class_id: item.id })
                .then(response => {
                    if (response) {
                        this.historyData = this.$store.getters.HISTORIALES_TIME_LINE.historiales
                        this.showHistory = true
                        this.loadingHistory = false
                    } else {
                        this.loadingHistory = false
                    }
                })
        },

        searchData: _.debounce(function() {
            this.loadData(this.grupoEstado)
        }, 1000),

        getChipColor(item) {
            switch (item.estado) {
                case 1:
                    return "success lighten-1"
                case 0:
                    return "grey lighten-1"
            }
        },

        getIconColor(data) {
            switch (data.item.value) {
                case "1":
                    return "black"
                case "2":
                    return "success lighten-1"
                case "3":
                    return "grey lighten-1"
                default:
                    return "black"
            }
        }
    },

    computed: {
        ...mapGetters(["GRUPOS"]),

        pagination: {
            get: function() {
                return this.$store.getters.GRUPOS_PAG
            },
            set: function(value) {
                this.$store.commit("SET_GRUPOS_PAG", value)
            }
        },
        searchTerm() {
            return this.filter.search
        }
    },

    watch: {
        pagination: {
            handler() {
                this.loadData(this.grupoEstado)
            },
            deep: true
        },
        searchTerm() {
            this.searchData()
        }
    },

    created() {
        if (this.gradoParam) {
            localStorage.setItem("grado_id", JSON.stringify(this.gradoParam.id))
        }
    },

    mounted() {
        let grado = localStorage.getItem("grado_id")
        this.gradoId = JSON.parse(grado)

        this.$store.dispatch("LOAD_GRADO_DETAILS_GRUPOS", { id: this.gradoId }).then(result => {
            if (result) {
                this.gradoData = result
            }
        })
    }
}
</script>
